import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame, X } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { Manat } from "./PriceBadge";

const PRICE = /(\d[\d\s.,]*\s*₼\S*)/;
const pad = (n) => String(n).padStart(2, "0");

function useLeft(until) {
  const calc = () => (until ? Math.max(0, Math.floor((new Date(until).getTime() - Date.now()) / 1000)) : null);
  const [left, setLeft] = useState(calc);
  useEffect(() => {
    setLeft(calc());
    if (!until) return;
    const id = setInterval(() => setLeft(calc()), 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [until]);
  return left;
}

const Unit = ({ v, l }) => (
  <span className="offer-unit"><b>{pad(v)}</b><i>{l}</i></span>
);

export default function OfferBanner() {
  const { config } = useSite();
  const c = config.contacts || {};
  const key = `lm_offer_closed_${c.offer_text}_${c.offer_ends_at}`;
  const [closed, setClosed] = useState(() => sessionStorage.getItem(key) === "1");
  const left = useLeft(c.offer_ends_at);
  useEffect(() => setClosed(sessionStorage.getItem(key) === "1"), [key]);
  if (!c.offer_enabled || !c.offer_text || closed || left === 0) return null;
  const [before, price, after] = c.offer_text.split(PRICE);
  const close = () => { sessionStorage.setItem(key, "1"); setClosed(true); };
  return (
    <div className="offer-banner" role="region" aria-label="Aksiya" data-testid="offer-banner">
      <Link to="/#contact" className="flex items-center gap-3 min-w-0" data-testid="offer-banner-link">
        <span className="offer-flame"><Flame size={17} /></span>
        <span className="min-w-0">
          <span className="block text-[13px] sm:text-sm font-semibold text-[#F3EEE4] truncate" data-testid="offer-banner-text">
            {before}{price && <span className="text-[#F3D592]"><Manat text={price} /></span>}{after}
          </span>
          {left != null && (
            <span className="offer-count" data-testid="offer-banner-countdown">
              {left >= 86400 && <Unit v={Math.floor(left / 86400)} l="gün" />}
              <Unit v={Math.floor((left % 86400) / 3600)} l="saat" />
              <Unit v={Math.floor((left % 3600) / 60)} l="dəq" />
              <Unit v={left % 60} l="san" />
            </span>
          )}
        </span>
      </Link>
      <button onClick={close} aria-label="Bağla" className="offer-close" data-testid="offer-banner-close"><X size={15} /></button>
    </div>
  );
}
